import clsx from "clsx";
import type { ReactNode } from "react";

interface Tab {
  key: string;
  label: ReactNode;
  count?: number;
}

interface Props {
  tabs: Tab[];
  active: string;
  onChange: (key: string) => void;
  className?: string;
}

export function Tabs({ tabs, active, onChange, className }: Props) {
  return (
    <div className={clsx("border-b border-surface-200 dark:border-slate-800", className)}>
      <nav className="-mb-px flex gap-2" aria-label="Tabs">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => onChange(t.key)}
            className={clsx(
              "flex items-center gap-2 whitespace-nowrap border-b-2 px-3 py-2.5 text-sm font-medium transition-colors",
              active === t.key
                ? "border-brand-600 text-brand-700"
                : "border-transparent text-slate-500 dark:text-slate-400 hover:border-surface-300 dark:border-slate-700 hover:text-slate-700",
            )}
          >
            {t.label}
            {t.count !== undefined && t.count > 0 && (
              <span
                className={clsx(
                  "inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1.5 text-xs font-semibold",
                  active === t.key
                    ? "bg-brand-100 text-brand-800"
                    : "bg-surface-200 text-slate-600 dark:text-slate-400",
                )}
              >
                {t.count}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
